import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '@components-library/Icons/iconsComponents';
import { Tooltip as AntdTooltip } from 'antd';
import type { AbstractTooltipProps } from 'antd/es/tooltip';
import cn from 'classnames';
import styles from './styles.module.scss';

interface ITooltipProps {
  content: string | ReactNode;
  children?: ReactNode;
  className?: string;
  rootClassName?: string;
  placement?: AbstractTooltipProps['placement'];
  open?: boolean;
  destroyTooltipOnHide?: boolean;
  useI18n?: boolean;
}

export const Tooltip = ({
  content,
  children,
  className,
  rootClassName,
  placement,
  open,
  destroyTooltipOnHide,
  useI18n = true,
}: ITooltipProps) => {
  const { i18n } = useTranslation();

  const tooltipContent = typeof content === 'string' && useI18n ? i18n.t(content) : content;

  const renderDefaultIcon = () => {
    return (
      <div className={styles.tooltipIcon}>
        <InfoIcon iconFill="currentColor" />
      </div>
    );
  };

  return (
    <AntdTooltip
      open={open}
      destroyTooltipOnHide={destroyTooltipOnHide}
      autoAdjustOverflow={true}
      placement={placement}
      className={className}
      rootClassName={cn(styles.tooltip, rootClassName)}
      title={tooltipContent}>
      {children || renderDefaultIcon()}
    </AntdTooltip>
  );
};
